import {
  DISCONNECT_QUICK_BOOKS_ACCOUNT,
  FETCH_QUICK_BOOKS_SETTINGS,
  STORE_QUICK_BOOKS_ACCOUNT_MAP,
} from './constants';

export default (state = {}, action) => {
  switch (action.type) {
    case FETCH_QUICK_BOOKS_SETTINGS:
      return {
        ...state,
        ...action.payload,
      };
    case STORE_QUICK_BOOKS_ACCOUNT_MAP:
      return {
        ...state,
        accountMap: action.payload,
      };
    case DISCONNECT_QUICK_BOOKS_ACCOUNT:
      return {
        ...state,
        isConnected: false,
        bankAccountTypes: [],
        depositAccounts: [],
        accountMap: null,
      };
    default:
      return state;
  }
};
